module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Shopping/Barcode-read-1cff1d852ac2c8a593bbf58a4874ff83.svg";